import moment from 'moment';

export const buildQueryParams = (query) => {
    const result = {};

    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('domestic') && query.get('domestic') !== 'all') {
        result.domestic = query.get('domestic') === 'domestic';
    }
    if (query.has('ground') && query.get('ground') !== 'all') {
        result.ground = query.get('ground') === 'ground';
    }
    if (query.has('service_levels')) {
        result.serviceLevelGroups = query.getAll('service_levels');
    }
    if (query.has('timeframe')) {
        result.timeframe = query.get('timeframe');
    }

    return result;
};
